import type { SendTripMessageInput, TripMessageThreadView, TripMessageView } from '@chukua/common';
import { api } from '../../../../shared/shared.api';

export type { TripMessageThreadView, TripMessageView };

export function getTripMessages(tripId: string): Promise<TripMessageThreadView> {
  return api<TripMessageThreadView>(`/trips/${tripId}/messages`);
}

export function sendTripMessage(tripId: string, input: Pick<SendTripMessageInput, 'body' | 'clientMessageId'>): Promise<TripMessageView> {
  return api<TripMessageView>(`/trips/${tripId}/messages`, { method: 'POST', body: JSON.stringify(input) });
}

/** Clears the driver's messages up to the newest one the screen showed. */
export async function markTripMessagesRead(tripId: string, upToMessageId: string): Promise<void> {
  await api<unknown>(`/trips/${tripId}/messages/read`, { method: 'PUT', body: JSON.stringify({ upToMessageId }) });
}
